import { Box, Dialog } from '@mui/material'
import { ReactComponent as CloseIcon } from 'assets/cross_close_logo.svg'
import { useEffect, useState } from 'react'
import { COLORS } from 'styles/colors'
import { CardStandart } from 'ui/CardStandart'
import { TypographyHeader } from 'ui/typography/TypographyHeader'
import { TypographySecondary } from 'ui/typography/TypographySecondary'
import { processImages } from '../processes'

const PhotoWidjet = props => {
	const { images } = props
	const [isShowCowModalPicture, setIsShowModalCowPicture] =
		useState<boolean>(false)
	const [showInfo, setShowInfo] = useState<string>('')

	const [processedImages, setProcessedImages] = useState([])

	useEffect(() => {
		const processAllImages = async () => {
			const updatedImages = await processImages(images)
			setProcessedImages(updatedImages)
		}

		processAllImages()
	}, [images])

	const onClickImage = (uri?: string) => {
		if (!uri) return
		setIsShowModalCowPicture(true)
		setShowInfo(uri)
	}
	const onCloseDialog = () => {
		setShowInfo('')
		setIsShowModalCowPicture(false)
	}

	const latestImage = processedImages[processedImages.length - 1]?.image

	return (
		<CardStandart
			sx={{
				p: 0,
				width: '100%',
				height: '100%',
				position: 'relative',
				overflow: 'hidden',
			}}
		>
			{processedImages?.length === 0 ? (
				<EmptyPhoto />
			) : (
				<img
					onClick={() => onClickImage(latestImage)}
					style={{
						width: '100%',
						height: '100%',
						objectFit: 'cover',
						cursor: 'pointer',
					}}
					src={latestImage}
					alt={`cow-image`}
				/>
			)}

			<Dialog
				maxWidth={'md'}
				open={isShowCowModalPicture}
				onClose={onCloseDialog}
				PaperProps={{
					style: {
						minWidth: '400px',
						borderRadius: '12px',
						padding: '24px',
					},
				}}
			>
				<Box
					sx={{
						display: 'flex',
						flexDirection: 'row',
						justifyContent: 'space-between',
						alignItems: 'center',
					}}
				>
					<TypographyHeader>Фото коровы</TypographyHeader>
					<CloseIcon
						onClick={onCloseDialog}
						stroke={COLORS.secondary}
						style={{ cursor: 'pointer' }}
					/>
				</Box>
				<Box sx={{ marginTop: '24px', maxWidth: '1100px' }}>
					<img
						style={{
							width: '100%',
							height: '100%',
							objectFit: 'cover',
						}}
						src={showInfo}
						alt={`cow-modal`}
					/>
				</Box>
			</Dialog>
		</CardStandart>
	)
}

export default PhotoWidjet

const EmptyPhoto = () => {
	return (
		<Box
			sx={{
				width: '100%',
				height: '100%',
				display: 'flex',
				alignItems: 'center',
				justifyContent: 'center',
				bgcolor: '#FFFFFF',
			}}
		>
			<TypographySecondary
				sx={{
					fontSize: '12px',
					color: '#7F7F84',
					textAlign: 'center',
				}}
			>
				Нет данных
			</TypographySecondary>
		</Box>
	)
}
